// Sons de pagamento sintetizados via Web Audio (sem asset externo, PWA-friendly).
// Opcoes: pix_elegante | caixa_premium | moedas | banco_digital | silencioso
let ctx = null;

function ensureCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

// Desbloqueia o audio no primeiro gesto do usuario (iOS/Safari exigem)
export function primeNotificationAudio() {
  ensureCtx();
}

function blip(c, freq, start, dur, { type = "sine", peak = 0.14 } = {}) {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, start);
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(peak, start + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start(start);
  o.stop(start + dur + 0.02);
}

function pixElegante(c, t) {
  // Duas notas ascendentes suaves + brilho
  blip(c, 784.0, t, 0.28, { type: "sine", peak: 0.16 });        // G5
  blip(c, 1046.5, t + 0.14, 0.34, { type: "sine", peak: 0.16 }); // C6
  blip(c, 1568.0, t + 0.30, 0.5, { type: "sine", peak: 0.08 });  // brilho G6
}

function caixaPremium(c, t) {
  // "cha-ching" de caixa registradora digital
  blip(c, 1318.5, t, 0.12, { type: "triangle", peak: 0.16 });    // E6 ding
  blip(c, 1760.0, t + 0.10, 0.5, { type: "triangle", peak: 0.13 }); // A6
  blip(c, 2093.0, t + 0.12, 0.55, { type: "sine", peak: 0.09 });  // C7 shimmer
  blip(c, 196.0, t + 0.02, 0.18, { type: "sine", peak: 0.10 });   // leve base
}

function moedas(c, t) {
  // Moedas caindo (blips curtos descendentes)
  const notes = [1760, 1568, 1318, 1046, 880];
  notes.forEach((f, i) => blip(c, f, t + i * 0.075, 0.12, { type: "triangle", peak: 0.12 }));
}

function bancoDigital(c, t) {
  // Triade marimba suave (C-E-G) arpejada
  blip(c, 523.25, t, 0.4, { type: "sine", peak: 0.15 });
  blip(c, 659.25, t + 0.10, 0.4, { type: "sine", peak: 0.14 });
  blip(c, 783.99, t + 0.20, 0.5, { type: "sine", peak: 0.13 });
}

const PLAYERS = {
  pix_elegante: pixElegante,
  caixa_premium: caixaPremium,
  moedas: moedas,
  banco_digital: bancoDigital,
};

export function playPaymentSound(kind = "pix_elegante") {
  if (kind === "silencioso") return;
  const c = ensureCtx();
  if (!c) return;
  const fn = PLAYERS[kind] || PLAYERS.pix_elegante;
  try { fn(c, c.currentTime + 0.02); } catch { /* ignore */ }
}

export const SOUND_LABELS = {
  pix_elegante: "Pix Elegante",
  caixa_premium: "Caixa Premium",
  moedas: "Moedas",
  banco_digital: "Banco Digital",
  silencioso: "Silencioso",
};
